import { useMediaQuery } from 'react-responsive';
import { mediaQueryMaxWidth } from "./Constants";
export function useIsMobile() {
  return useMediaQuery({
    maxWidth: mediaQueryMaxWidth
  });
}